module.exports = __webpack_public_path__ + "media/images/frontend/pages/processes-1-578c7cd2c9ea2b27c3f05377f4023055.jpg";